<template>
  <loadable :loading="isBusy" description="Načítání nastavení">
    <v-container fluild>
      <v-layout row wrap>
        <v-flex xs6>
          <configuration-basic v-model="item" />
        </v-flex>
        <v-flex xs6 v-if="isKey && item._self">
          <configuration-certificates v-model="item" />
        </v-flex>
      </v-layout>
    </v-container>
  </loadable>
</template>

<script>
import Configuration from '@/models/Configuration'
import ConfigurationBasic from '@/components/Configuration/Basic'
import ConfigurationCertificates from '@/components/Configuration/Certificates'

export default {
  data () {
    return {
      isBusy: false,
      item: {
        _self: null,
        maxAge: null,
        encrypt: 'NONE',
        compression: 'PCM',
        encryptionKey: null,
        insertIdent: false,
        certificates: []
      }
    }
  },
  created () {
    this.isBusy = true

    Configuration.getCurrent(this.$store.auth.user)
      .then(item => {
        if (item) {
          this.item._self = item._self
          this.item._links = item._links
          this.item.maxAge = item.maxAge
          this.item.encrypt = item.encrypt
          this.item.codecType = item.codecType
          this.item.insertIdent = item.insertIdent
          this.item.certificates = item.certificates
        }
        this.isBusy = false
      })
      .catch(() => {
        this.isBusy = false
      })
  },
  computed: {
    isKey () {
      return this.item.encrypt === 'KEY'
    }
  },
  components: {
    ConfigurationBasic,
    ConfigurationCertificates
  }
}

</script>



// WEBPACK FOOTER //
// Configuration.vue?c0a5c298